import { IFileStoreItem } from '../interfaces/IFileStoreItem';
import { GoogleFileInfo } from '../../models/googleFileInfo';

export class FileStoreItem implements IFileStoreItem {
    id: string;
    container: string;
    partition: string;
    contentType: string;
    size: number;
    link: string;
    date: Date;
    name: string;
    static fromGoogleFileInfo(file: GoogleFileInfo): FileStoreItem {
        const fileInfo = new FileStoreItem();
        fileInfo.id = file.Id;
        fileInfo.contentType = file.MimeType;
        fileInfo.name = file.Name;
        fileInfo.date = file.ModifiedTime;
        fileInfo.link = `https://drive.google.com/file/d/${file.Id}/view`;
        fileInfo.size = Number(file.Size);
        return fileInfo;
    }
    public static get empty() {
        return  {
            container: null,
            contentType: null,
            date: null,
            id: null,
            link: null,
            name: null,
            description: null,
            partition: null,
            size: null
          };
    }
}
